import { createExternalApi } from './apiFactory'

const client = createExternalApi({
  serviceName: 'signing-service',
})

// TODO: Remove this function and just return response.data in fetchSigningDocumentHtml
// after compliance update hard launch.
function parseDocumentHtmlBody(data: string, contentType: string): string {
  if (contentType.includes('application/json')) {
    const json: Record<string, unknown> = JSON.parse(data)
    const key = Object.keys(json)[0]
    const html = key != null ? json[key] : undefined
    if (typeof html !== 'string') {
      throw new Error('Failed to load document')
    }
    return html
  }

  return data
}

/** Fetches agreement HTML from the signing service (JSON-wrapped or raw text/html). */
export async function fetchSigningDocumentHtml(versionId: string): Promise<string> {
  const response = await client.get(`/documents/html?version_id=${encodeURIComponent(versionId)}`, {
    responseType: 'text',
  })

  const contentType = response.rawResponse.headers.get('Content-Type') ?? ''
  return parseDocumentHtmlBody(response.data, contentType)
}

export const signingApi = {
  ...client,
  fetchDocumentHtml: fetchSigningDocumentHtml,
}
